<template>
  <input
    v-if="allowDecimal"
    type="text"
    inputmode="decimal"
    class="form-control input-style text-right"
    autocomplete="off"
    :class="_class"
    :value="decimalInput"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="onDecimalInput"
    @blur="onDecimalBlur"
  />
  <b-form-input
    v-else
    class="input-style text-right"
    autocomplete="off"
    v-model="_value"
    v-bind:class="_class"
    :size="size"
    :formatter="formatter"
    :placeholder="placeholder"
    :disabled="disabled"
  ></b-form-input>
</template>
<script>
import { unMaskMoney, convertPrice } from '@/utils/common';
export default {
  props: {
    value: {
      value: '',
      required: true,
    },
    size: {
      value: null,
      default: 'sm',
    },
    placeholder: {
      value: null,
      default: 'Vui lòng nhập',
    },
    inputClass: {
      value: null,
      default: '',
    },
    disabled: {
      value: null,
      default: false,
    },
    allowDecimal: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'valueChange',
  },
  data() {
    return {
      decimalInput: this.formatDecimalInit(this.value),
    };
  },
  watch: {
    value(newVal) {
      if (!this.allowDecimal) return;
      const bufferNum = this.parseDecimal(this.decimalInput);
      const propNum = newVal == null || newVal === '' ? 0 : Number(newVal);
      if (bufferNum !== propNum) {
        this.decimalInput = this.formatDecimalInit(newVal);
      }
    },
    allowDecimal(isDecimal) {
      if (isDecimal) {
        this.decimalInput = this.formatDecimalInit(this.value);
      }
    },
  },
  computed: {
    _value: {
      get() {
        return this.value ? this.formatter(this.value) : null;
      },
      set(value) {
        this.$emit('valueChange', Number(unMaskMoney(value)));
      },
    },
    _class: {
      get() {
        return this.inputClass;
      },
    },
  },
  methods: {
    formatDecimalInit(val) {
      if (val == null || val === '' || val === 0 || val === '0') return '';
      const num = Number(val);
      return isNaN(num) ? '' : String(num);
    },
    parseDecimal(raw) {
      if (raw === null || raw === undefined || raw === '') return 0;
      const str = String(raw).replace(/[^\d.]/g, '');
      const parts = str.split('.');
      const cleaned =
        parts.length > 1 ? parts[0] + '.' + parts.slice(1).join('') : str;
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    },
    sanitizeDecimalInput(raw) {
      if (raw == null) return '';
      const str = String(raw).replace(/[^\d.]/g, '');
      const dotIdx = str.indexOf('.');
      if (dotIdx === -1) return str;
      const integerPart = str.slice(0, dotIdx);
      const decimalPart = str
        .slice(dotIdx + 1)
        .replace(/\./g, '')
        .slice(0, 2);
      return integerPart + '.' + decimalPart;
    },
    onDecimalInput(event) {
      const raw = event.target.value;
      const clean = this.sanitizeDecimalInput(raw);
      this.decimalInput = clean;
      if (event.target.value !== clean) {
        event.target.value = clean;
      }
      this.$emit('valueChange', this.parseDecimal(clean));
    },
    onDecimalBlur() {
      const num = this.parseDecimal(this.decimalInput);
      this.decimalInput = num === 0 && this.decimalInput.trim() === '' ? '' : String(num);
    },
    formatter(value) {
      return convertPrice(Number(unMaskMoney(value)));
    },
  },
};
</script>
